module.exports = __webpack_public_path__ + "c64c7cc55e86f803cf1a1952a2d4ee78.svg";